/**
 * Analytics
 * Analytics API
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = Raw, 1 = QuarterHour, 2 = Hour, 3 = Day
 */
export enum AnalyticsAggregationTier {
    Raw = 'raw',
    QuarterHour = '15m',
    Hour = '1h',
    Day = '1d'
}

